import { Label, ArticleParagraph1, ArticleParagraph2, TooltipDesktop } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './FloatingLabel.css';

export interface IFloatingLabelProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
  color: string;
  backgroundColor: string;
  icon?: React.ReactElement;
  extendTooltipContent?: React.ReactElement;
  link?: string;
  onOpen?: () => void;
}

export function FloatingLabel({
  labelText,
  tooltipText,
  tooltipTitle,
  color,
  backgroundColor,
  icon,
  extendTooltipContent,
  link,
  onOpen,
}: IFloatingLabelProps) {
  const content = (
    <div className={styles['container']}>
      <ArticleParagraph1 fontWeight="bold">{tooltipTitle}</ArticleParagraph1>
      <div className={styles['text']}>
        <ArticleParagraph2>{tooltipText}</ArticleParagraph2>
      </div>
      {link && (
        <ArticleParagraph2>
          <a className={styles['link']} href={link} rel="noreferrer noopener" target="_blank">
            Как это работает
          </a>
        </ArticleParagraph2>
      )}
      {extendTooltipContent && <div>{extendTooltipContent}</div>}
    </div>
  );

  return (
    <TooltipDesktop title={content} theme="white" placement="bottom-start" onOpen={onOpen}>
      <span className={styles['label']}>
        <Label color={color} background={backgroundColor} icon={icon}>
          {labelText}
        </Label>
      </span>
    </TooltipDesktop>
  );
}
